import { initializeApp } from 'firebase/app'
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA5SAzuPvnFdB4J5ZC1a3Lni-WIfHaDF9g",
  authDomain: "voyabay-hotels.firebaseapp.com",
  projectId: "voyabay-hotels",
  storageBucket: "voyabay-hotels.firebasestorage.app",
  messagingSenderId: "613050907930",
  appId: "1:613050907930:web:f46297741c3dc2da7e80a3",
  measurementId: "G-ZE10TMD9HF"
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

// Set auth persistence to local (persists across browser sessions)
setPersistence(auth, browserLocalPersistence).catch(console.error)

export const db = getFirestore(app)
export const functions = getFunctions(app)

export default app
